export default function ReportSales() {
  return <div></div>;
}
